<template>
    <div>
        <h1>Thank you for buying pro</h1>
    </div>
</template>

<script>
    export default {
        name: "ProWelcome"
    }
</script>

<style scoped>

</style>
